import { render, staticRenderFns } from "./swiperVueSlide.vue?vue&type=template&id=6a7363ff&scoped=true&"
import script from "./swiperVueSlide.vue?vue&type=script&lang=js&"
export * from "./swiperVueSlide.vue?vue&type=script&lang=js&"
import style0 from "./swiperVueSlide.vue?vue&type=style&index=0&id=6a7363ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7363ff",
  null
  
)

export default component.exports